import {checkRole, checkAction} from './rule';


function install(Vue) {
  if (install.installed) { return }
  install.installed = true;


  Object.defineProperty(Vue.prototype, '$lkAdmin', {
    get: function() {
      // this will be each <LkLayout />
      return this.$root._lkAdmin;
    },
  });


  Vue.mixin({
    created() {
      // when view
      const pnode = this.$options._parentVnode;
      if (pnode && pnode.data && pnode.data.registerRouteInstance) {
        this.$nextTick(() => this.$lkAdmin.mvcMayChange());
      }
    },

  });
}


export const methods = {
  setPreCheckPerm(fn) {
    this._preCheckPermFn = fn || null;
  },
  checkFn(fn, {preCheckPerm = true, ...opt} = {}) {
    if (preCheckPerm && this._preCheckPermFn) {
      const ret = this._preCheckPermFn({checkFn: fn}, opt, this.user);
      if (ret === true || ret === false) {
        return ret;
      }
    }

    return fn(opt.ctx, this.user);
  },
  checkAction(rule, {preCheckPerm = true, ...opt} = {}) {
    if (preCheckPerm && this._preCheckPermFn) {
      const ret = this._preCheckPermFn({checkAction: rule}, opt, this.user);
      if (ret === true || ret === false) {
        return ret;
      }
    }

    return checkAction(rule, this.user);
  },
  checkRole(rule, {preCheckPerm = true, ...opt} = {}) {
    if (preCheckPerm && this._preCheckPermFn) {
      const ret = this._preCheckPermFn({checkRole: rule}, opt, this.user);
      if (ret === true || ret === false) {
        return ret;
      }
    }

    return checkRole(rule, this.user);
  },
  checkPerm(checkDef, {preCheckPerm = true, ...opt}, {ctx: any, preCheckPerm: boolean, src: string} = {}) {
    if (preCheckPerm && this._preCheckPermFn) {
      const ret = this._preCheckPermFn(checkDef, opt, this.user);
      if (ret === true || ret === false) {
        return ret;
      }
    }

    opt.preCheckPerm = false;
    const {checkFn, checkAction, checkRole} = checkDef;

    if (checkFn) {
      return this.checkFn(checkFn, opt);
    } else if (checkAction) {
      return this.checkAction(checkAction, opt);
    } else if (checkRole) {
      return this.checkRole(checkRole, opt);
    } else {
      return true;
    }
  },
};


export default {install};
